import "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { a as g, i as p } from "./query-DolxHPXs-B8EMIjjI.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let d;
function h(t) {
  return (r, e) => g(r, e, { get() {
    var l;
    return ((l = this.renderRoot) != null ? l : d != null ? d : d = document.createDocumentFragment()).querySelectorAll(t);
  } });
}
const f = ({
  finisher: t,
  descriptor: r
}) => (
  // eslint-disable-next-line consistent-return
  (e, l) => {
    var o;
    if (l !== void 0) {
      const i = e.constructor;
      r !== void 0 && Object.defineProperty(e, l, r(l)), t == null || t(i, l);
    } else {
      const i = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (o = e.originalKey) != null ? o : e.key
      ), n = r !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: i,
        descriptor: r(e.key)
      } : { ...e, key: i };
      return t && (n.finisher = function(s) {
        t(s, i);
      }), n;
    }
  }
);
function c(t, r, e = {}, l = !1) {
  var o;
  const i = `slot${r ? `[name=${r}]` : ":not([name])"}`, n = (o = t.renderRoot) == null ? void 0 : o.querySelector(i);
  return n ? l ? n.assignedNodes(e).filter((s) => s.nodeType !== Node.COMMENT_NODE) : n.assignedElements(e) : [];
}
function v(t) {
  return typeof t == "string" ? { version: t } : t.alternateSlot !== void 0 && t.alternateSlot !== null ? { alternateSlot: t.alternateSlot, version: t.version } : { alternateAttribute: t.alternateAttribute, version: t.version };
}
function b(t, r = !1) {
  const { slot: e, selector: l, deprecated: o, flatten: i } = t != null ? t : {};
  let n;
  return o && (n = v(o)), f({
    descriptor: (s) => ({
      get() {
        let u = c(this, e, { flatten: i });
        return u.length === 0 && o && n && n.alternateSlot && (u = c(this, n.alternateSlot, { flatten: i })), l ? u == null ? void 0 : u.filter((a) => {
          var m;
          return r ? ((m = a == null ? void 0 : a.nodeName) == null ? void 0 : m.toLowerCase()) === this.getScopedTagName(l) : a.matches(l);
        }) : u;
      },
      set(u) {
        if (o) {
          const a = e != null ? e : "";
          this.alternateSlots.set(a, n);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function N(t) {
  return function(r, e) {
    return p(t)(r, e);
  };
}
function k(t, r) {
  return f({
    descriptor: (e) => ({
      get() {
        var l;
        return (l = this.querySelector(t)) != null ? l : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function q(t) {
  return function(r, e) {
    return h(t)(r, e);
  };
}
function A(t, r = !1) {
  const { slot: e, selector: l, deprecated: o, flatten: i } = t != null ? t : {};
  let n;
  return o && (n = v(o)), f({
    descriptor: (s) => ({
      get() {
        let u = c(this, e, { flatten: i }, !0);
        return u.length === 0 && o && n && n.alternateSlot && (u = c(this, n.alternateSlot, { flatten: i }, !0)), u;
      },
      set(u) {
        if (o) {
          const a = e != null ? e : "";
          this.alternateSlots.set(a, n);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  N as A,
  k as E,
  b as N,
  h as d,
  A as k,
  q
};
